import { ReactNode } from 'react';

import { useRole } from '../common/hooks/useRole';

import { SupplierSubscriptionPlansProvider } from './SupplierSubscriptionPlansProvider';

interface SupplierSubscriptionPlansScopeProps {
    children: ReactNode;
}

export const SupplierSubscriptionPlansScope = ({ children }: SupplierSubscriptionPlansScopeProps) => {
    const role = useRole();
    return role.isSupplier() && !role.isSuperAdmin() ? (
        <SupplierSubscriptionPlansProvider>{children}</SupplierSubscriptionPlansProvider>
    ) : (
        children
    );
};
